import { type FC } from 'react';
import {
  Handshake
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconHandshakeProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconHandshake: FC<UiIconHandshakeProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Handshake}
      {...props}
    />
  );
};
